export default "__VITE_ASSET__e8ab981b__"